export const FETCH_SUPPLIER_REQUEST = "FETCH_SUPPLIER_REQUEST";
export const FETCH_SUPPLIER_SUCCESS = "FETCH_SUPPLIER_SUCCESS";
export const FETCH_SUPPLIER_FAILURE = "FETCH_SUPPLIER_FAILURE";
